import { CompanyType } from './common-entities';

export enum Layout {
	Horizontal = 'horizontal',
	Inline = 'inline',
	Vertical = 'vertical',
}

export type CompanyItem = {
	value: string;
	label: string;
	companyType: CompanyType;
	landingId?: string;
	alias?: string;
};

export type CompanyList = CompanyItem[];
